module.exports = __webpack_public_path__ + "img/festivity_emt.a888206c.png";